export default __webpack_public_path__ + "static/media/social-img-2.2dfc59ab.jpg";